"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
// progress bar
// progress bar style

_nprogress.default.configure({
  showSpinner: false
}); // 不显示进度环

var whiteList = ["/login", "/apply", "/guest/*", "/h5/*"]; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken, hasMenu, _yield$store$dispatch, menu, accessRoutes;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start();

            // 当访问login并且query.token存在,就进入页面
            if (!(to.name == 'login' && to.query.token)) {
              _context.next = 5;
              break;
            }
            next();
            _nprogress.default.done();
            return _context.abrupt("return");
          case 5:
            // determine whether the user has logged in
            hasToken = (0, _auth.getToken)();
            if (!hasToken) {
              _context.next = 41;
              break;
            }
            if (!(to.path === "/login" || to.path === "/404" && from.name === "login")) {
              _context.next = 12;
              break;
            }
            // if is logged in, redirect to the home page
            next({
              path: "/"
            });
            _nprogress.default.done();
            _context.next = 39;
            break;
          case 12:
            hasMenu = _store.default.getters.menu && _store.default.getters.menu.length > 0;
            if (!hasMenu) {
              _context.next = 17;
              break;
            }
            next();
            _context.next = 39;
            break;
          case 17:
            _context.prev = 17;
            _context.next = 20;
            return _store.default.dispatch("user/getMenu");
          case 20:
            _yield$store$dispatch = _context.sent;
            menu = _yield$store$dispatch.menu;
            if (!(menu.length > 0)) {
              _context.next = 30;
              break;
            }
            _context.next = 25;
            return _store.default.dispatch("permission/generateRoutes", menu);
          case 25:
            accessRoutes = _context.sent;
            // dynamically add accessible routes
            _router.default.addRoutes(accessRoutes);
            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
              replace: true
            }));
            _context.next = 31;
            break;
          case 30:
            _store.default.dispatch("user/logout");
          case 31:
            _context.next = 39;
            break;
          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](17);
            _context.next = 37;
            return _store.default.dispatch("user/resetToken");
          case 37:
            // Message.error({ message: error.msg || "Has Error" });
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          case 39:
            _context.next = 43;
            break;
          case 41:
            console.log('to.path', to.path);
            /* has no token*/
            if (isWhiteList(to.path)) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));
              _nprogress.default.done();
            }
          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[17, 33]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});
function isWhiteList(path) {
  var flag = false;
  if (whiteList.length) {
    whiteList.forEach(function (node) {
      if (node.indexOf('*') > -1) {
        node = node.replace('/*', '');
        if (path.indexOf(node) > -1) {
          flag = true;
        }
      } else if (path == node) {
        flag = true;
      }
    });
  }
  return flag;
}